import { ContextDropdown, type ContextField } from "@appretio/context-selector";
import { FORECAST_CONTEXT_FIELD_LABELS } from "../../forecastContext";
import { contextGrid } from "./manageCubesOperations.css";

/** Props for the manage-cubes context filter grid. */
interface CubeContextFilterGridProps {
  /** Full cube context options keyed by context field. */
  options: Record<string, string[]> | undefined;
  /** Filtered context options keyed by context field. */
  filteredOptions: Record<string, string[]> | undefined;
  /** Current context selections keyed by context field. */
  selections: Record<string, string[]>;
  /** True when filtered options should be shown. */
  hasActiveFilters: boolean;
  /** Whether context values are currently loading. */
  isLoading: boolean;
  /** Setter for a context field selection. */
  setSelected: (field: ContextField, values: string[]) => void;
}

/** Shared context dropdown grid used by manage-cubes operation forms. */
export function CubeContextFilterGrid({
  options,
  filteredOptions,
  selections,
  hasActiveFilters,
  isLoading,
  setSelected
}: CubeContextFilterGridProps) {
  return (
    <div className={contextGrid}>
      {FORECAST_CONTEXT_FIELD_LABELS.map(({ key }) => {
        const allValues = options?.[key] ?? [];
        if (allValues.length === 0) return null;
        const filtered = filteredOptions?.[key] ?? [];

        return (
          <ContextDropdown
            key={key}
            field={key as ContextField}
            options={allValues}
            filteredOptions={hasActiveFilters ? filtered : []}
            isLoading={isLoading}
            selected={selections[key] ?? []}
            setSelected={setSelected}
          />
        );
      })}
    </div>
  );
}
